import {Component, isDevMode, OnInit} from '@angular/core';
import {NaverLoginService} from "../../shared/services/naver-login/naver-login.service";
import {APP_VERSION} from "../../shared/defines/client.const";

import $ from 'jquery';


@Component({
  selector: 'app-cb-naver-android',
  templateUrl: './cb-naver-android.component.html',
  styleUrls: ['./cb-naver-android.component.scss']
})
export class CbNaverAndroidComponent implements OnInit {
  public readonly APP_VERSION = isDevMode() ? APP_VERSION : '';

  naverLoginInstance: any;

  constructor(
    private naverLoginSvc: NaverLoginService,
    // private option: OptionService
  ) {
    (window as any).$ = $;

    // this.option.startAnim = false;
  }

  ngOnInit(): void {
    this.naverLoginSvc.GetUserProfile().subscribe((naverKey: string) => {
      let data: any = {id: naverKey};
      data = JSON.stringify(data);
      // window.alert(data);

      if (!window['webkit']?.messageHandlers['cordova_iab']) {
        console.warn('Cordova IAB postMessage API not found!');
      } else {
        console.log('Message sent!');
        window['webkit']?.messageHandlers['cordova_iab'].postMessage(data);
      }
    });
  }
}
